/**
 * Created by henian.xu on 2018/7/18.
 *
 */

import { Sv } from './Sv';

class CertExamCourseDetail extends Sv {
    constructor() {
        super();
        this.baseUrl += '/certExamCourseDetail';
    }

    data({ certExamCourseId, courseCatName, currentPage, pageSize } = {}) {
        return super.get('/data', {
            certExamCourseId,
            courseCatName,
            currentPage,
            pageSize,
        });
    }

    getDetail({ id }) {
        return super.get('/get', { id }).then(json => {
            const { fileBasePath } = json.data.data;
            const { courseImage } = json.data.data.certExamCourseDetail;
            if (!courseImage) {
                json.data.data.certExamCourseDetail.courseImage = [];
            } else {
                json.data.data.certExamCourseDetail.courseImage = courseImage.split(',').reduce((prev, curr) => {
                    prev.push({
                        name: curr,
                        address: fileBasePath + curr,
                    });
                    return prev;
                }, []);
            }
            return json;
        });
    }

    save({
        id,
        certExamCourseId,
        certExamCourseCatId,
        courseName,
        courseImage,
        coursewareId,
        courseDesc,
        courseHour,
        isTrySee,
        orderNum,
        validMinutes,
        courseAuthType,
        faceAuthRate,
        questionAuthRate,
        questionAuthTime,
    } = {}) {
        const courseImageStr = courseImage
            .reduce((prev, curr) => {
                prev.push(curr.name);
                return prev;
            }, [])
            .join(',');
        return super.post(
            '/save',
            {
                id,
                certExamCourseId,
                certExamCourseCatId,
                courseName,
                courseImage: courseImageStr,
                coursewareId,
                courseDesc,
                courseHour,
                isTrySee,
                orderNum,
                validMinutes,
                courseAuthType,
                faceAuthRate,
                questionAuthRate,
                questionAuthTime,
            },
            { timeout: 0 },
        );
    }

    delete({ ids } = {}) {
        return super.post('/delete', {
            ids,
        });
    }

    select() {
        return super.get('/select', {});
    }
}

export default new CertExamCourseDetail();
export { CertExamCourseDetail };
